<template>
  <UiModal
    modal-styles="mobile-bottom tablet-bottom"
    @close="$emit('close')"
    @value="(e: Event) => $emit('value', e)"
    @input="(e: Event) => $emit('input', e)"
  >
    <perfect-scrollbar @close="$emit('close')">
      <div class="feedback-container">
        <h3 class="text-h3-bold-up">Оставить отзыв</h3>
        <div ref="form">
          <form
            ref="fileForm"
            class="form"
            novalidate
            @submit.prevent="onSubmit"
          >
            <div class="input">
              <div class="rating-container">
                <span class="text-body-m-book"
                  >Ваша оценка товара: <span>{{ textRating }}</span></span
                >
                <div class="rating">
                  <template v-for="item in ratingList" :key="item">
                    <label
                      v-if="item > 0"
                      :key="`label-${item}`"
                      :for="`rating-${item}`"
                    ></label>
                    <input
                      :id="`rating-${item}`"
                      v-model="scoreRating"
                      :value="item"
                      type="radio"
                      name="rating"
                      class="rating-input"
                      @click="v$.$reset()"
                    />
                  </template>
                </div>
              </div>
              <span v-if="v$.score.$errors[0]" class="error-message"
                >Необходимо оценить товар</span
              >
            </div>

            <div class="title-container">
              <p class="text-body-m-book">
                Поделитесь впечатлениями о&nbsp;товаре
              </p>
            </div>
            <UiPTextarea
              ref="textarea"
              v-model:value="feedbackItem.pros"
              max-length="2000"
              :auto-height="true"
              name="pros"
              class="pros input"
              placeholder="Достоинства"
            >
              <template #right>
                <ui-char-counter :max="2000" :value="feedbackItem.pros" />
              </template>
            </UiPTextarea>

            <UiPTextarea
              ref="textarea"
              v-model:value="feedbackItem.cons"
              max-length="2000"
              :auto-height="true"
              name="cons"
              class="cons input"
              placeholder="Недостатки"
            >
              <template #right>
                <ui-char-counter :max="2000" :value="feedbackItem.cons" />
              </template>
            </UiPTextarea>

            <div class="input">
              <UiPTextarea
                ref="textarea"
                v-model:value="feedbackItem.extract"
                max-length="2000"
                :auto-height="true"
                name="extract"
                class="cons input"
                placeholder="Общие впечатления"
                :error="v$.extract.$errors[0] ? showErrorMessage : ''"
                @focus="v$.$reset()"
              >
                <template #right>
                  <ui-char-counter :max="2000" :value="feedbackItem.extract" />
                </template>
              </UiPTextarea>
            </div>

            <div class="title-container">
              <p class="text-body-m-book">Добавьте фото</p>
              <p class="text-body-m-book_subtitle">
                До&nbsp;8&nbsp;изображений&nbsp;&mdash; jpeg, png, webp. Вес
                одного файла&nbsp;&mdash; до&nbsp;50&nbsp;MB
              </p>
            </div>
            <div
              id="file-drag-drop"
              ref="divPreview"
              :class="[
                'file_drag-drop',
                { 'file_drag-drop__padding': files.length > 0 },
              ]"
            >
              <div class="file-image__wrapper">
                <div
                  v-for="(file, key) in files"
                  :key="key"
                  class="file-listing"
                >
                  <img
                    :key="jsShow"
                    class="js-drag-drop__preview"
                    :src="file.src"
                    alt="img"
                  />
                  <a class="file-image__container" @click="removeFile(key)"
                    ><img
                      class="file-image__remove"
                      src="/static/images/icon/close-share.svg"
                      alt="close"
                  /></a>
                </div>
                <input
                  id="upload-file__input"
                  ref="inputFileLoads"
                  class="upload-file__input"
                  type="file"
                  multiple
                  @change="handleFileUpload()"
                />
                <label
                  for="upload-file__input"
                  :class="[
                    'file_wrapper-before-load',
                    { 'file_wrapper-before-load_baseline': files.length > 0 },
                  ]"
                >
                  <img
                    v-if="files.length < 8"
                    :class="[
                      'file_img-load',
                      { 'file_img-load__loaded': files.length > 0 },
                    ]"
                    src="/static/images/loadfiles.svg"
                    alt="load files"
                  />
                  <span v-if="!(files.length > 0)" class="file_img-title">
                    <span>Выберите фотографии</span> или перетащите их&nbsp;сюда
                  </span>
                </label>
              </div>
              <p v-if="files.length > 0" class="file_drag-drop__counter">
                Загружено {{ files.length }}/8
              </p>
            </div>
            <div v-if="isErrorInImageFile" class="info-error__wrapper">
              <img
                class="info-error__icon"
                src="/static/images/icon/info_error.svg"
                alt="info"
              />
              <RenderHTML
                tag-wrapper="p"
                :seotext="textOutError"
                class-wrapper="info-error__text"
              />
            </div>

            <div class="title-container">
              <p class="text-body-m-book">Ваши данные</p>
            </div>
            <div class="row input">
              <div class="author">
                <UiPInput
                  ref="author"
                  v-model:value="feedbackItem.author"
                  name="author"
                  placeholder="Имя"
                  :error="v$.author.$errors[0] ? showErrorMessage : ''"
                  @focus="v$.$reset()"
                />
              </div>

              <div class="email">
                <UiPInput
                  ref="email"
                  v-model:value="feedbackItem.email"
                  name="email"
                  placeholder="E-mail"
                  :error="v$.email.$errors[0] ? showErrorMessage : ''"
                  @focus="v$.$reset()"
                />
              </div>
            </div>
            <ui-ui-button
              class="submit-button"
              :resize="true"
              @click="onSubmit"
            >
              Отправить отзыв
            </ui-ui-button>
          </form>
        </div>
        <div class="disclaimer">
          Нажимая кнопку «Отправить отзыв», вы
          <a
            class="visual_disclaimer"
            target="_blank"
            href="https://static.price.ru/docs/PriceExpressAggreement3.pdf"
            >соглашаетесь</a
          >
          с
          <a
            class="visual_disclaimer"
            target="_blank"
            href="https://static.price.ru/docs/PriceExpressPersonalDataPolicy.pdf"
            >политикой обработки персональных данных</a
          >
          и
          <nuxt-link
            class="visual_disclaimer"
            target="_blank"
            to="/user-agreement/"
            >пользовательским соглашением
          </nuxt-link>
          и на получение информационных и рекламных сообщений
        </div>
      </div>
    </perfect-scrollbar>
  </UiModal>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import noShowImg from './noShowImg.js';
import { API } from '~/api/api';
import type {
  FeetBackModalItem,
  FileResponse,
  ReviewAxiosResponse,
} from '~/interfaces/app';
import RenderHTML from '~/components/ui/RenderHTML.vue';

interface IFileItem {
  lastModified: number;
  lastModifiedDate?: string;
  name: string;
  size: number;
  type: string;
  webkitRelativePath: string;
  src?: string;
  id?: string;
}

export default defineComponent({
  name: 'FeedbackModal',
  components: {
    RenderHTML,
  },
  props: {
    modelId: {
      type: Number,
      default: 0,
    },
  },
  emits: ['value', 'input', 'close'],
  setup(props, ctx) {
    const ratingList = [0, 20, 40, 60, 80, 100];
    const feedbackItem = ref<FeetBackModalItem>({
      model_id: props.modelId,
      score: 0,
      author: '',
      email: '',
      pros: '',
      cons: '',
      extract: '',
      date: '',
      photo_ids: [],
    });
    const scoreRating = ref(0);
    const mustBeGreaterZero = (value: number) => {
      return value > 0;
    };
    const rulesFeedbackItem = {
      model_id: props.modelId,
      score: { required, mustBeGreaterZero },
      author: { required },
      email: { required, email },
      pros: '',
      cons: '',
      extract: { required },
      date: '',
      photo_ids: [] as string[], // or number[] depending on the actual type,
    };

    const textRating = ref<string>('');
    const dragAndDropCapable = ref<boolean>(false);
    const files = ref<IFileItem[]>([]);
    const inputFileLoads = ref<{ files: FileList | null }>({ files: null });
    const fileForm = ref();
    const divPreview = ref();
    const isErrorInImageFile = ref<boolean>(false);
    const jsShow = ref<number>(0);
    const textOutError = ref<string>('');
    const textErrorIfNotFormat =
      'К&nbsp;отзыву можно добавить фотографии только в&nbsp;формате jpeg, png, webp';
    const textErrorIfManyFiles = 'Можно добавить до&nbsp;8&nbsp;изображений.';
    const textErrorIfBigFiles = 'Размер файла&nbsp;превышает&nbsp;50&nbsp;MB';
    const maxSizeFile = 104857600; // 104857600 - 100 мегабайт
    const showErrorMessage = 'Поле обязательно для заполнения';
    const { $ymAnyEvent } = useNuxtApp();

    async function onSubmit() {
      $ymAnyEvent('reachGoal', 'send_otzyv');
      await v$.value.$validate();
      if (v$.value.$error) return;
      feedbackItem.value.date = new Date().toISOString().slice(0, 10);
      feedbackItem.value.photo_ids = files.value.map(
        (item: IFileItem) => item.id
      );
      await API.post(
        `/models/${props.modelId}/reviews`,
        feedbackItem.value
      ).catch((e) => console.error('post reviews error', e));
      ctx.emit('close', 'success');
    }

    let timer: ReturnType<typeof setTimeout>;
    let timerRefresh: ReturnType<typeof setTimeout>;
    let timerClearShowError: ReturnType<typeof setTimeout>;

    const debounce = (rating: number, timeout = 300) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        switch (rating) {
          case 100:
            textRating.value = 'Отличный товар';
            break;
          case 80:
            textRating.value = 'Хороший товар';
            break;
          case 60:
            textRating.value = 'Обычный товар';
            break;
          case 40:
            textRating.value = 'Плохой товар';
            break;
          case 20:
            textRating.value = 'Ужасный товар';
            break;
          default:
            textRating.value = '';
        }
      }, timeout);
    };

    const debounceRefresh = () => {
      clearTimeout(timerRefresh);
      timerRefresh = setTimeout(() => {
        jsShow.value++;
      }, 100);
    };

    const clearShowError = () => {
      clearTimeout(timerClearShowError);
      timerClearShowError = setTimeout(() => {
        isErrorInImageFile.value = false;
      }, 4000);
    };

    const determineDragAndDropCapable = () => {
      const div = document.createElement('div');
      return (
        ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
        'FormData' in window &&
        'FileReader' in window
      );
    };

    watch(scoreRating, () => {
      debounce(scoreRating.value);
      feedbackItem.value.score = scoreRating.value;
    });

    const addSrcInFile = (file: Blob) => {
      const reader = new FileReader();
      const img = document.createElement('img');
      reader.onload = (function (img) {
        return function (e) {
          if (!/(jpe?g|png|webp)$/i.test(file.type) && e && e?.target) {
            img.src = noShowImg;
          } else if (e && e.target) {
            img.src = e.target.result as string;
          }
        };
      })(img);
      reader.readAsDataURL(file);
      return reader;
    };
    const sendFilesOnServer = async (file: FileResponse) => {
      const formData = new FormData();
      formData.append('file', file);
      await API.post(`/models/reviews/images`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((res: ReviewAxiosResponse) => {
          file.id = res?.id || res?.data?.id;
        })
        .catch((error) => {
          files.value.forEach((item, index) => {
            if (file?.name === item?.name) {
              removeFile(index);
              if (error.response.status === 400) {
                textOutError.value =
                  'Соотношение сторон изображения превышает 1:5';
              } else if (error.response.status === 413) {
                textOutError.value = 'Загрузка изображения больше 50МБ';
              } else {
                textOutError.value = 'Ошибка загрузки файла на сервер';
              }
              isErrorInImageFile.value = true;
              clearShowError();
            }
          });
        });
    };

    const checkCondition = (file: string) => {
      return /\.(jpe?g|png|tga|webp|xmp|heic)$/i.test(file);
    };

    const dragDropFunction = (event: DragEvent) => {
      if (files.value.length >= 8) {
        textOutError.value = textErrorIfManyFiles;
        isErrorInImageFile.value = true;
        clearShowError();
        return;
      }
      if (event?.dataTransfer?.files?.length) {
        for (let i = 0; i < event.dataTransfer.files.length && i < 8; i++) {
          if (event.dataTransfer.files[i].size > maxSizeFile) {
            textOutError.value = textErrorIfBigFiles;
            isErrorInImageFile.value = true;
            clearShowError();
            continue;
          }
          if (event.dataTransfer.files.length > 8) {
            textOutError.value = textErrorIfManyFiles;
            isErrorInImageFile.value = true;
            clearShowError();
          }
          if (checkCondition(event.dataTransfer.files[i]?.name)) {
            const isFileAlreadyAdded = files.value.find(
              (item: IFileItem) =>
                item?.name === event?.dataTransfer?.files[i].name
            );
            if (!isFileAlreadyAdded && files.value.length < 8) {
              const file = event.dataTransfer.files[i];
              addSrcInFile(file);
              sendFilesOnServer(file).then(() => {});
              files.value.push(event.dataTransfer.files[i]);
              debounceRefresh();
            }
          } else {
            textOutError.value = textErrorIfNotFormat;
            isErrorInImageFile.value = true;
            clearShowError();
          }
        }
      }
    };

    const removeFile = (key: number) => {
      files.value.splice(key, 1);
    };

    const handleFileUpload = () => {
      if (!inputFileLoads?.value?.files) return;
      for (let i = 0; i < inputFileLoads.value.files.length && i < 8; i++) {
        const file = inputFileLoads.value.files[i];
        if (file.size > maxSizeFile || files.value.length > 8) {
          textOutError.value =
            file.size > maxSizeFile
              ? textErrorIfBigFiles
              : textErrorIfManyFiles;
          isErrorInImageFile.value = true;
          clearShowError();
          continue;
        }

        if (inputFileLoads.value.files.length > 8) {
          textOutError.value = textErrorIfManyFiles;
          isErrorInImageFile.value = true;
          clearShowError();
        }

        if (!checkCondition(file.name)) {
          textOutError.value = textErrorIfNotFormat;
          isErrorInImageFile.value = true;
          clearShowError();
          continue;
        }
        // iphone when load any photo from camera shot always use name image.jpg
        const isFileAlreadyAdded = files.value.find(
          (item: IFileItem) =>
            item?.name === file.name && item?.size === file?.size
        );

        if (!isFileAlreadyAdded && files.value.length < 8) {
          addSrcInFile(file);
          files.value.push(file);
        }
        sendFilesOnServer(file).then(() => {});
      }

      debounceRefresh();
    };

    const addEventsFiles = (flag: boolean) => {
      if (!flag) return;
      dragAndDropCapable.value = determineDragAndDropCapable();
      if (dragAndDropCapable.value && divPreview.value) {
        [
          'drag',
          'dragstart',
          'dragend',
          'dragover',
          'dragenter',
          'dragleave',
          'drop',
        ].forEach((event) => {
          divPreview.value.addEventListener(
            event,
            (e: Event) => {
              e.preventDefault();
              e.stopPropagation();
            },
            false
          );
        });
        divPreview.value.addEventListener('drop', (event: DragEvent) =>
          dragDropFunction(event)
        );
      }
    };
    onBeforeUnmount(() => {
      [
        'drag',
        'dragstart',
        'dragend',
        'dragover',
        'dragenter',
        'dragleave',
        'drop',
      ].forEach((event) => {
        divPreview.value.removeEventListener(
          event,
          (e: Event) => {
            e.preventDefault();
            e.stopPropagation();
          },
          false
        );
      });

      divPreview.value.removeEventListener('drop', (event: DragEvent) =>
        dragDropFunction(event)
      );
    });

    onMounted(() => {
      setTimeout(() => {
        addEventsFiles(true);
      }, 1000);
    });

    const v$ = useVuelidate(rulesFeedbackItem, feedbackItem);

    return {
      ratingList,
      feedbackItem,
      onSubmit,
      textRating,
      dragAndDropCapable,
      files,
      inputFileLoads,
      fileForm,
      divPreview,
      isErrorInImageFile,
      jsShow,
      removeFile,
      handleFileUpload,
      textOutError,
      v$,
      showErrorMessage,
      scoreRating,
    };
  },
});
</script>
<style scoped lang="scss" src="./feedback-modal.scss" />
